import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer'
import SurveyGridHeader from '../components/GridComponents/SurveyGridHeader';
import SurveyGridBody from '../components/GridComponents/SurveyGridBody';
import SurveyGridRow from '../components/GridComponents/SurveyGridRow';
import {
    CommonResponses,
    ElementType,
    NumberFormat,
    PlaceholderFormat,
    SelectCombos,
} from '../Enums/constants';
import {getCurrencyPlaceHolder} from "../helpers";
import SurveyConditionalSegment from "../components/SurveyConditionalSegment";


export const PabsLgCostsTab = () => {
    let currencyPlaceHolderThousands = getCurrencyPlaceHolder(PlaceholderFormat.CURRENCY_THOUSANDS);
    return (
        <SurveyPage>
            <SurveyTitleArea pageName="Costs"/>
            <SurveyContentContainer>
                <SurveySection labelText="Administration Costs">
                    <SurveyElement questionNumber="11" labelText={`Complete the following table below (in ${currencyPlaceHolderThousands}):`}/>
                    <SurveyElement
                        questionNumber="11.a" name="Q_25"
                        labelText="Total administrative expenses per your financial statements (ACFR in the U.S.)"
                        placeholder={currencyPlaceHolderThousands}
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement labelText="Minus, if included in administrative expenses:"/>
                    <SurveyElement
                        questionNumber="11.b" name="SACRSCostHealthcare"
                        labelText="Healthcare administration costs"
                        placeholder={currencyPlaceHolderThousands}
                        allowNA
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement
                        questionNumber="11.c" name="SACRSCostOptional"
                        labelText="Optional and third party administered benefits, such as tax deferred savings plans, loans, dental, etc."
                        placeholder={currencyPlaceHolderThousands}
                        allowNA
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement
                        questionNumber="11.d" name="InvestmentCosts"
                        labelText="Investment administration costs"
                        placeholder={currencyPlaceHolderThousands}
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement
                        questionNumber="11.e" name="AccruedPensionOPEBCosts"
                        labelText="Accrued, non-cash, pension and OPEB expense (per U.S. GASB 68 &amp; 75, if applicable)"
                        placeholder={currencyPlaceHolderThousands}
                        allowUnknown
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement labelText="Plus, if not included in administrative expenses:"/>
                    <SurveyElement
                        questionNumber="11.f" name="SACRSDepnAmt"
                        labelText="Amortization and depreciation of administrative assets"
                        placeholder={currencyPlaceHolderThousands}
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement
                        questionNumber="11.g" name="SACRSActuarialAmt"
                        labelText="Actuarial and all other professional fees relating to pension administration"
                        placeholder={currencyPlaceHolderThousands}
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement
                        questionNumber="11.h" name="CashPensionOPEBCosts"
                        labelText="Cash contributions for pension and OPEB, for active staff"
                        placeholder={currencyPlaceHolderThousands}
                        allowUnknown
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement
                        name="TotalBenefitAdministrationExpenses"
                        labelText="Total benefit administration expenses"
                        note="to be attributed in the Cost and Staff by Activity table below"
                        formula="Q_25+SACRSDepnAmt+SACRSActuarialAmt+CashPensionOPEBCosts-InvestmentCosts-AccruedPensionOPEBCosts-SACRSCostHealthcare-SACRSCostOptional"
                        inputType={ElementType.CALCULATED} format={NumberFormat.MONEYTHOUSAND}/>

                    <SurveyElement questionNumber="12" labelText="Provide the breakdown of your benefit administration expenses from question 11 above:"/>
                    <SurveyElement
                        questionNumber="12.a" name="SACRSSalariesAndBenefits"
                        labelText="Salaries and benefits"
                        placeholder={currencyPlaceHolderThousands}
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement
                        questionNumber="12.b" name="SACRSProfessionalFees"
                        labelText="Professional fees"
                        note="actuarial, legal, audit, consulting, outsourced IT, etc."
                        placeholder={currencyPlaceHolderThousands}
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement
                        questionNumber="12.c" name="SACRSBuildingExpenses"
                        labelText="Building expenses"
                        note="rent, depreciation, utilities, facility services, amortization of lease holds"
                        placeholder={currencyPlaceHolderThousands}
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement
                        questionNumber="12.d" name="UKCostAmortisation"
                        labelText="Amortization and depreciation"
                        note="non-building"
                        placeholder={currencyPlaceHolderThousands}
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement
                        questionNumber="12.e" name="SACRSOtherAdminExpenses"
                        labelText="Other administrative expenses"
                        placeholder={currencyPlaceHolderThousands}
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion/>
                    <SurveyElement
                        name="TotalAdministrativeExpenses"
                        labelText="Total administrative expenses"
                        formula="SACRSSalariesAndBenefits+SACRSProfessionalFees+SACRSBuildingExpenses+UKCostAmortisation+SACRSOtherAdminExpenses"
                        inputType={ElementType.CALCULATED} format={NumberFormat.MONEYTHOUSAND}/>

                    <SurveyElement inputType="grid" styleName={"dataTable pabsCostTable"}>
                        <SurveyGridHeader>
                            <SurveyElement
                                questionNumber="13"
                                labelText="Are any of the following services provided free of charge, or at a subsidized cost, by a sister organization?"
                                note="Cost should be included in cost allocation above."
                                inputType={ElementType.LABEL}/>
                            <SurveyElement
                                labelText="Provided by sister org?<br />(yes/ no)"
                                inputType={ElementType.LABEL}/>
                            <SurveyElement
                                labelText="Free of charge? <br />(yes/ no)"
                                inputType={ElementType.LABEL}
                            />
                        </SurveyGridHeader>
                        <SurveyGridBody>
                            <SurveyGridRow>
                                <SurveyElement questionNumber="13.a"
                                    labelText="Building?"
                                    inputType={ElementType.LABEL}/>
                                <SurveyElement
                                    name="SisterBuilding"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO}/>
                                <SurveyElement
                                    name="SisterBuildingFree"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO_NA}
                                    showIf={{SisterBuilding: {not: CommonResponses.NO}}}/>
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement questionNumber="13.b"
                                    labelText="IT services?"
                                    inputType={ElementType.LABEL}/>
                                <SurveyElement
                                    name="SisterIT"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO}/>
                                <SurveyElement
                                    name="SisterITfree"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO_NA}
                                    showIf={{SisterIT: {not: CommonResponses.NO}}}/>
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement questionNumber="13.c"
                                    labelText="Actuarial services?"
                                    inputType={ElementType.LABEL}/>
                                <SurveyElement
                                    name="Sisteractuarial"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO}/>
                                <SurveyElement
                                    name="SisterActuarialFree"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO_NA}
                                    showIf={{Sisteractuarial: {not: CommonResponses.NO}}}/>
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement questionNumber="13.d"
                                    labelText="Pension payroll?"
                                    inputType={ElementType.LABEL}/>
                                <SurveyElement
                                    name="SisterPayroll"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO}/>
                                <SurveyElement
                                    name="SisterPayrollFree"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO_NA}
                                    showIf={{SisterPayroll: {not: CommonResponses.NO}}}/>
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement questionNumber="13.e"
                                    labelText="Member data maintenance?"
                                    inputType={ElementType.LABEL}/>
                                <SurveyElement
                                    name="SisterData"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO}/>
                                <SurveyElement
                                    name="SisterDataFree"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO_NA}
                                    showIf={{SisterData: {not: CommonResponses.NO}}}/>
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement questionNumber="13.f"
                                    labelText="Other? (describe)"
                                    inputType={ElementType.LABEL}/>
                                <SurveyElement
                                    name="SisterOther"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO}/>
                                <SurveyElement
                                    name="SisterOtherFree"
                                    pageName="Costs"
                                    inputType={ElementType.SELECT} options={SelectCombos.YES_NO_NA}
                                    showIf={{SisterOther: {not: CommonResponses.NO}}}/>
                            </SurveyGridRow>
                            <SurveyElement
                                name="SisterOtherDesc"
                                inputType={ElementType.TEXTAREA}
                                showIf={{SisterOther: {not: CommonResponses.NO}}}
                            />
                        </SurveyGridBody>
                    </SurveyElement>

                    <SurveyElement
                        questionNumber="14" name="FTEDB"
                        labelText="Provide the number of full-time equivalent (&quot;FTE&quot;) of all staff whose compensation is included in 12a above."
                        note="i.e. the full time equivalent of all administrative staff, less health care, non-pension and optional benefit, and investment administration staff, less staff whose salaries were capitalized. <br />Include the FTEs who are under contract, part-time and non-permanent. For example, a person who works 3 days a week counts as 0.6 FTE. Do not include the FTE of unfilled positions."
                        placeholder="# FTE"
                        inputType={ElementType.NUMBER} format={NumberFormat.DECIMAL1}
                    />
                    
                    <SurveyElement
                        questionNumber="15" name="SACRSCapitalizeAdminYN"
                        labelText="Did you capitalize any pension administration related costs last year?"
                        inputType={ElementType.SELECT} options={SelectCombos.YES_NO}/>
                    <SurveyElement
                        questionNumber="15.a" name="SACRSCapitalizeAdminAmt"
                        labelText="What is the total amount capitalized?"
                        placeholder={currencyPlaceHolderThousands}
                        allowNA allowUnknown
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion
                        showIf={{SACRSCapitalizeAdminYN: {not: CommonResponses.NO}}}/>
                    
                    <SurveyElement
                        questionNumber="16" name="SACRSIncludeMPCosts"
                        labelText="Did you have any major project costs that were not capitalized?"
                        inputType={ElementType.SELECT} options={SelectCombos.YES_NO}/>
                    <SurveyElement
                        questionNumber="16.a" name="CostMPNotMulti"
                        labelText="What were your total non-capitalized major project costs?"
                        placeholder={currencyPlaceHolderThousands}
                        allowNA
                        inputType={ElementType.NUMBER} format={NumberFormat.MONEYTHOUSAND} subQuestion
                        showIf={{SACRSIncludeMPCosts: {not: CommonResponses.NO}}}/>
                </SurveySection>
            </SurveyContentContainer>
        </SurveyPage>
    )
}